<template>
  <template v-if="question?.status !== 'READ_ONLY'">
    <div class="inputContainer form-group mb-1 ">
    <span v-if="question.type === 'currency' || question.type === 'money_medium'" :class="{
      'errorMessage' :isInvalid && hasBeenInteractedWith,
      'showDollar': (!question.placeholder && !question.prompt) || !inputValue,
      'userFocus': isCurrentlyFocused || inputValue
    }" class="user-select-none dollar-placeholder">$</span>

      <div class="d-flex w-100" :class="{
            'invalid': isInvalid && hasBeenInteractedWith
            }">
        <input
            v-bind="$attrs"
            ref="inputRef"
            :type="isNumber ? 'tel':'text'"
            :class="{
            'invalid': isInvalid && hasBeenInteractedWith
            }"
            class="choice quill-question-input flex-grow-1"
            :style="{
              outline:'none',
            }"
            :disabled="(question.status?.toLowerCase() !== 'editable') || disabled"
            :id="`waffle_${question.name}`"
            :name="'waffle_'+question.name"
            :value="displayValue"
            :aria-describedby="`${question.name}_describedby`"
            @input="handleInput"
            @keyup="$emit('prelim-value-update', inputValue)"
            @blur="question.type === 'search' ? $emit('user-interaction'): this.handleQuestionSubmission()"
            @keydown.tab="question.type === 'search' ? null: this.handleQuestionSubmission()"
            @focusin="isCurrentlyFocused = true; $event.target.setSelectionRange(inputValue?.length, inputValue?.length); moveCursorToEnd()"
            @focusout="isCurrentlyFocused = false;"
            @keydown.enter.prevent.stop="question.type === 'search' ? null: this.handleQuestionSubmission()">
        <button
            :disabled="(question.status?.toLowerCase() !== 'editable') || disabled"
            v-if="question.type === 'search'"
            class="d-flex justify-content-center align-items-center searchBtn"
            :class="{invalidBtn: isInvalid && hasBeenInteractedWith}"
            @click.stop="this.handleQuestionSubmission()"
        >
          <i>
            <svg width="16px" height="16px">
              <path id="search_FILL0_wght400_GRAD0_opsz24" d="M134.756-824l-5.6-5.6a5.3,5.3,0,0,1-1.533.844,5.418,5.418,0,0,1-1.844.311,5.577,5.577,0,0,1-4.1-1.678,5.577,5.577,0,0,1-1.678-4.1,5.577,5.577,0,0,1,1.678-4.1,5.577,5.577,0,0,1,4.1-1.678,5.577,5.577,0,0,1,4.1,1.678,5.577,5.577,0,0,1,1.678,4.1,5.417,5.417,0,0,1-.311,1.844,5.3,5.3,0,0,1-.844,1.533l5.6,5.6Zm-8.978-6.222a3.857,3.857,0,0,0,2.833-1.167,3.857,3.857,0,0,0,1.167-2.833,3.857,3.857,0,0,0-1.167-2.833,3.857,3.857,0,0,0-2.833-1.167,3.857,3.857,0,0,0-2.833,1.167,3.857,3.857,0,0,0-1.167,2.833,3.857,3.857,0,0,0,1.167,2.833A3.857,3.857,0,0,0,125.778-830.222Z" transform="translate(-120 840)" :fill="isInvalid && hasBeenInteractedWith ? '#BB0000': displayValue ? '#212121':`#949494`"/>
            </svg>
          </i>
        </button>
      </div>
      <span class="quill-question-placeholder placeholder-wrap" :class="{'placeholder-adjusment':inputValue ||isCurrentlyFocused,}"
      >
      {{ forcePromptPlaceholder ? question.prompt : question.placeholder }}
    </span>

    </div>
    <slot name="helptext" :isConfirm="!disableConfirm && (question?.value && question?.prefilled) && !isInvalid" :isError="isInvalid"
          :confirmCb="() =>{$emit('user-interaction'); $emit('confirm'); }"></slot>
  </template>
  <ReadOnly
      v-else
      :question="question"
      :value="displayValue? (question?.type === 'currency' ? '$'+ displayValue:displayValue):'-'"
      :forcePromptPlaceholder="forcePromptPlaceholder"
  />
</template>
<script>
import {Mask} from "maska2"
import ReadOnly from "@/components/waffle/components/form-components/ReadOnly.vue";

export default {
  name: "InputText",
  components: {ReadOnly},

  props: [
    'modelValue',
    'question',
    'hideSubText',
    'forcePromptPlaceholder',
    'isNumber',
    'skipEagerValidation',
    'disableConfirm',
    'hasBeenInteractedWith',
    'disabled'
  ],
  emits: ['update:modelValue', 'field-error', 'confirm', 'user-interaction', 'prelim-value-update'],
  data() {
    return {
      inputValue: '',
      isInvalid: null,
      isCurrentlyFocused: false,
      mask: null
    }
  },
  mounted() {
    if(this.question.value){
      this.inputValue = this.question.value;
    }
    if (this.frontendCriteria?.mask) {
      this.mask = new Mask({mask: Array.isArray(this.frontendCriteria.mask) ? this.frontendCriteria.mask:[this.frontendCriteria.mask]})
    }

    if (!this.skipEagerValidation) {
      this.validateInput()
    }
    if (this.question.error) {
      this.isInvalid = this.question.error
      this.$emit('field-error', true)
    }
  },
  computed: {
    frontendCriteria() {
      return this.question.criteria?.find(el => typeof el === 'object')
    },
    displayValue() {
      const isPII = this.question.criteria.find(el => typeof el === 'object')?.pii_masking

      if ((this.mask && this.inputValue && this.isCurrentlyFocused) || (this.mask && this.inputValue && !this.isCurrentlyFocused && !isPII)) {
        return this.mask.masked(this.inputValue)
      }else if(this.mask && this.inputValue && !this.isCurrentlyFocused && isPII){
        let output = this.mask.masked(this.inputValue)
        return output.substring(0, output.length-2).replace(/[a-zA-Z0-9]/g,'*') + output.substring(output.length-2)
      }else if(isPII && !this.isCurrentlyFocused){
        return this.inputValue.substring(0, this.inputValue.length-2).replace(/[a-zA-Z0-9]/g,'*') + this.inputValue.substring(this.inputValue.length-2)
      }
      return this.inputValue
    }
  },
  watch: {
    question: {
      handler(newQuestion) {
        if (newQuestion.value) {
          if(this.inputValue !== newQuestion.value){
            this.$emit('update:modelValue', newQuestion.value)
          }
          this.inputValue = newQuestion.value
          return this.validateInput(newQuestion.error)
        }
        if (newQuestion.error) {
          this.isInvalid = newQuestion.error
          this.$emit('field-error', true)
          return
        }
        this.inputValue = ""
      },
      deep: true,
    }
  },
  methods: {
    moveCursorToEnd() {
      const input = this.$refs.inputRef;
      input.selectionStart = input.selectionEnd = input.value.length;
    },
    handleInput(e) {
      this.inputValue = e.target.value
      if (this.mask) {
        this.inputValue = this.mask.unmasked(e.target.value)
      }
      return this.validateInput()
    },
    handleQuestionSubmission(){
      this.$emit('user-interaction');
      this.emitChange()
    },
    restrictToNumbers() {
      if (this.isNumber) {
        this.inputValue = this.inputValue?.replace(/[^0-9]/g, "") ?? '';
      }
      if (this.frontendCriteria?.restriction) {
        const regex = new RegExp(this.frontendCriteria.restriction, 'g')
        this.inputValue = this.inputValue?.replace(regex, "") ?? '';
      }
      if(this.frontendCriteria?.charLength){
        this.inputValue = this.inputValue.substring(0, this.frontendCriteria?.charLength)
      }
    },
    emitChange() {
      if (this.inputValue) {
        this.inputValue = this.inputValue?.trim()
      }
      if (this.validateInput()) {
        this.$emit('update:modelValue', this.inputValue)
      }
    },
    validateInput(errorMsg) {
      this.restrictToNumbers()
      if(errorMsg){
        this.isInvalid = errorMsg
        this.$emit('field-error', true)
        return false
      }
      const val = this.inputValue
      if (this.question && this.question.required) {
        if (!val) {
          this.isInvalid = 'Required'
          this.$emit('field-error', true)
          return false
        } else {
          this.isInvalid = null
          this.$emit('field-error', false)
        }
      }

      if (this.question && this.question.criteria) {

        if (this.isNumber && this.frontendCriteria?.min_value && Number(val) < this.frontendCriteria?.min_value) {
          this.isInvalid = `Value cannot be less than ${this.frontendCriteria?.min_value}`
          this.$emit('field-error', true)
          return false
        }

        if (this.isNumber && this.frontendCriteria?.max_value && Number(val) > this.frontendCriteria?.max_value) {
          this.isInvalid = `Value cannot be more than ${this.frontendCriteria?.max_value}`
          this.$emit('field-error', true)
          return false
        }

        if (this.frontendCriteria && this.frontendCriteria.regex) {

          const regex = new RegExp(this.frontendCriteria.regex)
          if (!regex.test(this.question.type === 'phone' ? this.displayValue : val)) {
            this.isInvalid = `Invalid entry`
            this.$emit('field-error', true)
            return false
          } else {
            this.isInvalid = null
            this.$emit('field-error', false)
          }
        }
      }
      this.isInvalid = null
      this.$emit('field-error', false)
      return true
    }
  },
}
//TODO:CLEAN UP AND REFINE CSS
</script>

<style scoped lang="scss">
.searchBtn{
  outline: none;
  border: none;
  border-left: 1px solid #ccc;
  border-top-right-radius: 3px;
  border-bottom-right-radius: 3px;
  width:50px;
  height: 100%
}

.invalidBtn{
  border-bottom-color: transparent !important;
  border-top-color: transparent !important;
  border-right-color: transparent !important;
}

.dollar-placeholder {
  position: absolute;
  padding-left: 12px;
  font-size: 16px;
  width: 12px;
  padding-top: 13px;
  font-weight: bold;
  transition: .3s;
  color: #757575
}

.align-text-end {
  text-align: end;
}

.subtext {
  font-size: .75rem;
  font: normal normal normal 12px/18px Roboto;
  letter-spacing: 0px;
  margin-bottom: 4px;
  color: #757575
}

.errorMessage {
  color: #BB0000
}

.gap {
  margin-right: 10px;
}

.quill-question {

  > div.inputContainer {
    position: relative;
    max-height: 50px;
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    cursor: pointer;

    > div{
      border: 1px solid #ccc;
      border-radius: 3px;
      &:hover:not(.invalid), &:focus:not(.invalid), &:focus-within:not(.invalid) ,&:focus-visible:not(.invalid) {
        border: 2px solid #212121;
        box-shadow: none;
        border-radius: 3px;
      }
    }


    > div >.quill-question-input {
      box-sizing: border-box;
      border: none;
      padding: 8px 12px;
      width: 100%;
      font-size: 16px;
      font-weight: bold;
      background: transparent;
      min-height: 100%;
      @media screen and (max-width: 768px) {
        min-width: auto !important;
        // flex: 0 0 45% !important;
      }

      &:has(~.question-type-unknown) {
        border-color: #BB0000;
      }

      &:hover:not(.invalid), &:focus:not(.invalid), &:focus-within:not(.invalid) ,&:focus-visible:not(.invalid) {
        outline: none;
        box-shadow: none;
        padding: 15px 5px;
      }

      &:disabled {
        background-color: #EEEEEE;
      }

    }

    > div + .quill-question-placeholder {
      position: absolute;
      padding: 10px 12px;
      line-height: 2em;
      top: 0;
      left: 0;
      color: #757575;
      font-size: 16px;
      pointer-events: none;
      transform: scale(1);
      transition: .26s all ease;
    }
  }
}

/*TODO convert to scss*/


.quill-question > div.inputContainer  div > input.quill-question-input:focus,
.quill-question > div.inputContainer  div > input.quill-question-input:not(.radio,:placeholder-shown) {
  padding: 25px 8px 8px 12px !important;
}

.quill-question > div.inputContainer .userFocus ~ div > input.quill-question-input:not(.radio,:placeholder-shown),
.quill-question > div.inputContainer .userFocus ~ div > input.quill-question-input:focus {
  padding: 24px 8px 2px 25px !important;
}

.inputContainer .userFocus{
  padding: 24px 8px 6px 13px !important;
  color: #212121;
}
.inputContainer span:not(.errorMessage) .showDollar{
  color: #757575;
}
.showDollar ~ .quill-question-placeholder {
    padding-left: 32px !important;
}
.userFocus ~ .quill-question-placeholder {
    padding-left: 12px !important;
}
.placeholder-adjusment.quill-question-placeholder {
  font-size: 12px !important;
  padding-top:6px !important;
  padding-right: 8px !important;
  padding-bottom:12px !important;
  padding-left:12px ;
}


.form-floating > .form-control:focus ~ label.form-label-text, .form-floating > .form-control:focus ~ label {
  font-size: 12px;
  color: #484848;
  padding-top: 1rem;
}

.form-control-disabled:hover {
  border: none;
}

.form-control-enabled:hover {
  border: 2px solid #212121
}

.invalid:not(.quill-question-input) {
  border: 1px solid #BB0000 !important;
  border-radius: 3px;

  &:hover, &:focus, &:focus-within {
    border: 2px solid #BB0000 !important;
  }
}

</style>